import React, { memo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { SubmissionButtons, TextArea } from '@components/common';

import { isEmpty } from '@utils/common';

import { ICreateCartRequestFormValues } from '@interfaces/rent/assetCart';
import { ISendAssetCartRequestDTO } from '@interfaces/rent/dto/assetCartDTO';

import { EValidationMode } from '@enums/validationMode';

import { validationSchema } from './schema';

interface IAcquireAssetFormProps {
	closeModal: () => void;
	handleSendAssetCartRequest: ({ comments, isSingleRequest }: ISendAssetCartRequestDTO) => void;
	isSingleRequest: boolean;
}

const CreateCartRequestForm = ({
	closeModal,
	handleSendAssetCartRequest,
	isSingleRequest,
}: IAcquireAssetFormProps) => {
	const {
		register,
		formState: { errors },
		handleSubmit,
	} = useForm<ICreateCartRequestFormValues>({
		mode: EValidationMode.onSubmit,
		resolver: yupResolver(validationSchema),
		defaultValues: {
			comments: '',
		},
	});

	const onSubmit = (values: ICreateCartRequestFormValues) => {
		handleSendAssetCartRequest({ comments: values.comments, isSingleRequest });

		closeModal();
	};

	return (
		<>
			<TextArea
				errorMessage={errors?.comments?.message}
				label='Comment'
				name='comments'
				placeholder='Leave a comment'
				register={register}
				rows={5}
				withUseForms
			/>
			<SubmissionButtons
				disabledPositive={!isEmpty(errors)}
				negativeHandler={closeModal}
				positiveHandler={handleSubmit(onSubmit)}
				positiveLabel='Submit'
			/>
		</>
	);
};

export default memo(CreateCartRequestForm);
